import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const adminTermsApi = createApi({
  reducerPath: "admin-terms",
  tagTypes: ["Terms"],
  baseQuery: createCustomFetchBaseQuery(),
  endpoints: (builder) => ({

    // ✅ Get all terms
    getAllTerms: builder.query({
      query: ({ pageno, search ,sortOrder , sortBy , category, limit }) => {
        let url = `admin/estimator-terms?pageno=${pageno}`;

        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }
        if(sortBy){
          url += `&sortBy=${sortBy}`;
        }
        if(sortOrder){
          url += `&sortOrder=${sortOrder}`;
        }
        if(category){
          url += `&category=${category}`;
        }
        if(limit){
          url += `&limit=${limit}`;
        }

        return {
          url,
          method: "GET",
        };
      },
      transformResponse: (res) => res,
      providesTags: ["Terms"],
    }),

    // ✅ Get single term by ID
    getTermById: builder.query({
      query: (id) => `admin/term/${id}`,
      transformResponse: (res) => res?.body,
      providesTags: ["Terms"],
    }),

    // ✅ Add new term
    addNewTerm: builder.mutation({
      query: (newTerm) => ({
        url: `admin/term`,
        method: "POST",
        body: newTerm,
      }),
      invalidatesTags: ["Terms"],
    }),

    // ✅ Update term
    updateTerm: builder.mutation({
      query: (updatedTerm) => ({
        url: `admin/term/${updatedTerm.id}`,
        method: "PUT",
        body: updatedTerm,
      }),
      invalidatesTags: ["Terms"],
    }),

    // ✅ Delete term
    deleteTerm: builder.mutation({
      query: (id) => ({
        url: `admin/term/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Terms"],
    }),

  }),
});

export const {
  useGetAllTermsQuery,
  useGetTermByIdQuery,
  useAddNewTermMutation,
  useUpdateTermMutation,
  useDeleteTermMutation,
} = adminTermsApi;
